import React, { useEffect, useState, useLayoutEffect } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import {
  Card,
  Row,
  TableBodyStyled,
  TableCellStyled,
  TableRowStyled,
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  Span,
  Button,
  Image,
  Col,
  CollapseColumn
} from 'components'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useLoading, useModal, useReportPrint } from 'hooks'
import moment from 'moment'
import { useHistory, useLocation } from 'react-router-dom'
import {
  ReportsAcessServices,
  RequestGetVisualizar
} from 'services/NGT/ReportsAcess'
import { COLORS, FONTS, FORMAT, SPACING } from 'utils'
import { createArrayCopy } from 'utils/functions'
import { Box, LinearProgress } from '@mui/material'
import InfiniteScroll from 'react-infinite-scroll-component'
const ContractView: React.FC = () => {
  const { setLoading, setMsgErro, setMsgSucesso } = useLoading()
  const { goBack } = useHistory()
  const { state } = useLocation<any>()
  const { handlePrintRelatorioDeAcessoPorContrato } = useReportPrint()

  const { showModal } = useModal()

  const [grupos, setGrupos] = useState<ResponseReports | undefined>()

  useLayoutEffect(() => {
    setLoading('loading')

    if (!state) {
      goBack()
      return
    }

    getRelatorio()
  }, [state])

  const getRelatorio = async () => {
    const objEnvio: RequestGetVisualizar = {
      ...(state.resquestVisualizar.contratosIds && {
        contratosIds: state.resquestVisualizar.contratosIds
      }),
      ...(state.resquestVisualizar.dataFim && {
        dataFim: state.resquestVisualizar.dataFim
      }),
      ...(state.resquestVisualizar.dataIni && {
        dataIni: state.resquestVisualizar.dataIni
      }),
      centrosIds: state?.resquestVisualizar.centrosIds,
      empresasIds: state?.resquestVisualizar.empresasIds,
      flStatus: state?.resquestVisualizar.flStatus,
      fornecedoresIds: state?.resquestVisualizar.fornecedoresIds,
      perfil: state?.resquestVisualizar.perfil,
      subcontratadasIds: state?.resquestVisualizar.subcontratadasIds,
      unidadeGestoraId: state?.resquestVisualizar.unidadeGestoraId
    }

    ReportsAcessServices()
      .getContrato(objEnvio)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(
            response?.data?.message ||
            response?.data?.mensagem ||
            'Erro obter relatório.'
          )
        }
        setGrupos(response.data)
        setLoading('idle')
      })
      .catch((error) => {
        if (error?.response?.data?.mensagem) {
          // setMsgSucesso(error?.response?.data?.mensagem, 'Atenção', 'alert')
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: error.response.data.mensagem,
            type: 'alert'
          })
          return
        }
        // setMsgErro('Erro ao obter relatório.')
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error?.response?.data?.mensagem,
          type: 'error'
        })
      })
  }

  const handleExcel = () => {
    setLoading('loading')
    if (
      state.resquestVisualizar.dataIni == null ||
      state.resquestVisualizar.dataIni === ''
    ) {
      delete state.resquestVisualizar.dataIni
    }
    if (
      state.resquestVisualizar.dataFim == null ||
      state.resquestVisualizar.dataFim === ''
    ) {
      delete state.resquestVisualizar.dataFim
    }
    ReportsAcessServices()
      .getContratoExcel(state.resquestVisualizar)
      .then((response) => {
        const url =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
          response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = 'relatorio-de-acesso-contrato.xlsx'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setLoading('idle')
      })
      .catch((error) => {
        // setMsgErro(
        //   error.response.data.mensagem ||
        //   error.response.data.message ||
        //   'Não foi possivel baixar excel.'
        // )
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.response.data.mensagem ||
            error.response.data.message ||
            'Não foi possivel baixar excel.',
          type: 'error'
        })
      })
  }

  const groupBy = (xs, key) => {
    return (
      xs &&
      xs.reduce((rv, x) => {
        rv[x[key]] = rv[x[key]] || []
        rv[x[key]].push(x)
        return rv
      }, {})
    )
  }

  const grouped = groupBy(grupos && grupos.resultado, 'contrato')
  const groupEntries = grouped && Object.entries(grouped)
  const groupEntriesTreated =
    groupEntries &&
    groupEntries.map((item) => {
      return { isOpen: false, items: [...item] }
    })
  const [finalGroup, setFinalGroup] = useState<any>([])
  const [slicedList, setSlicedList] = useState<any[]>([])
  const DEFAULT_SCROLL_LOAD_ITEMS = 20

  const nextPagination = (grupos: any[]) => {
    setTimeout(() => {
      const currentLength = slicedList.length
      const newItems = grupos.slice(
        currentLength,
        currentLength + DEFAULT_SCROLL_LOAD_ITEMS
      )
      setSlicedList((prevState) => prevState.concat([...newItems]))
    }, 1000)
  }

  useEffect(() => {
    setFinalGroup(groupEntriesTreated)
    setSlicedList(groupEntriesTreated?.slice(0, DEFAULT_SCROLL_LOAD_ITEMS))
  }, [
    groupEntriesTreated && groupEntriesTreated.length > 0
      ? null
      : groupEntriesTreated
  ])

  const handleCollpasePdf = (index: number) => {
    const cpySliced = createArrayCopy(slicedList)
    cpySliced[index].isOpen = !cpySliced[index].isOpen
    setSlicedList(cpySliced)
    const cpy = createArrayCopy(finalGroup)
    cpy[index].isOpen = !cpy[index].isOpen
    setFinalGroup(cpy)
  }

  return (
    <Card
      boxShadow="0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12);"
      borderRadius="0px 10px 0px 0px"
      marginTop={SPACING.spacing20}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
    // padding="1rem"
    // backgroundColor={COLORS.white}
    >
      <div>
        <HeaderSupplierTitle />
        <Row justifyContent="flex-end" alignItems="center">
          <RowPdfExcel
            handlePDF={() =>
              handlePrintRelatorioDeAcessoPorContrato({
                filename: `relatório-de-acesso-contrato-${moment().format(
                  'DD-MM-YYYY'
                )}`,
                title: 'RELATÓRIO DE ACESSO POR CONTRATO',
                data: finalGroup.map((grupo) => ({
                  cdContrato: grupo.items[1][0].contrato,
                  nmFornecedor: grupo.items[1][0]?.fornecedor,
                  de: grupo.items[1][0].de || '---',
                  dir: grupo.items[1][0].dir || '---',
                  gg: grupo.items[1][0].gg || '---',
                  ger: grupo.items[1][0].ger || '---',
                  body: grupo.items[1].map((item) => [
                    item.colaborador || '---',
                    FORMAT.documento(item.cpfpassaporte) || '---',
                    FORMAT.contatoInternacional(item.contato) || '---',
                    item.email || '---',
                    FORMAT.formatDDMMYYYY(item.vldAcesso) || '---',
                    item.perfil || '---',
                    item.status || '---'
                  ])
                }))
              })
            }
            handleExcel={handleExcel}
          />
          <Button
            marginTop={SPACING.spacing20}
            marginBottom={SPACING.spacing20}
            marginRight={SPACING.spacing5}
            text="Voltar"
            variantButton="outlined"
            onClick={() => goBack()}
          />
        </Row>
        <InfiniteScroll
          dataLength={slicedList?.length}
          next={() => nextPagination(finalGroup)}
          hasMore={finalGroup?.length > slicedList?.length}
          loader={
            <Box sx={{ width: '100%', marginBottom: '20px' }}>
              <LinearProgress />
            </Box>
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Final da listagem</b>
            </p>
          }
          releaseToRefreshContent={
            <h3 style={{ textAlign: 'center' }}>&#8593; Atualizando...</h3>
          }
        >
          {slicedList ? (
            slicedList?.map((el: any, index: number) => (
              <CollapseColumn
                key={index.toString()}
                nuContrato={el.items[1][0]?.contrato}
                nmFornecedor={el.items[1][0]?.fornecedor}
                nmDiretoriaExecutiva={el.items[1][0]?.de || '---'}
                nmDiretoria={el.items[1][0]?.dir || '---'}
                nmGerenciaGeral={el.items[1][0]?.gg || '---'}
                nmGerencia={el.items[1][0]?.ger || '---'}
                isOpen={el.isOpen}
                toggleExpand={() => handleCollpasePdf(index)}
                index={index}
              >
                <TableContractView data={el?.items[1]} />
              </CollapseColumn>
            ))
          ) : (
            <></>
          )}
        </InfiniteScroll>
      </div>
      <Row justifyContent="flex-end" alignItems="center">
        <Button
          marginTop={SPACING.spacing20}
          marginBottom={SPACING.spacing20}
          marginRight={SPACING.spacing5}
          text="Voltar"
          variantButton="outlined"
          onClick={() => goBack()}
        />
      </Row>
    </Card>
  )
}

const RowPdfExcel = ({ handlePDF, handleExcel }) => (
  <Row
    alignItems="center"
    justifyContent="end"
    marginTop={SPACING.spacing15}
    marginBottom={SPACING.spacing15}
  >
    <Row alignItems="center">
      <PdfIcon onClick={handlePDF} />
      <ExcelIcon style={{ marginLeft: `{SPACING.spacing15}` }} onClick={handleExcel} />
    </Row>
  </Row>
)

const HeaderSupplierTitle = () => (
  <Card backgroundColor={COLORS.headerColor} padding={SPACING.spacing20}>
    <Row alignItems="center" justifyContent="left">
      <Col gap=".7rem" alignItems="center" justifyContent="left">
        <CsnLogo width="62" height="40" />
        <Image src={Logotipo} width="3.8rem" />
      </Col>
    </Row>
    <Span
      text="RELATÓRIO DE ACESSO POR CONTRATO"
      color={COLORS.blueFonts}
      fontSize="24px"
      fontWeight={FONTS.bold}
      textTransform="uppercase"
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    />
  </Card>
)

const TableContractView = ({ data }) => (
  <TableContainerStyled>
    <TableStyled>
      <TableHeadStyled>
        <TableRowStyled>
          <TableCellStyled align="left">Colaborador</TableCellStyled>
          <TableCellStyled align="left">CPF/Passaporte</TableCellStyled>
          <TableCellStyled align="left">Contato</TableCellStyled>
          <TableCellStyled align="left">E-mail</TableCellStyled>
          <TableCellStyled align="left">Vld.Acesso</TableCellStyled>
          <TableCellStyled align="left">Perfil</TableCellStyled>
          <TableCellStyled align="left">Status</TableCellStyled>
        </TableRowStyled>
      </TableHeadStyled>
      <TableBodyStyled>
        {data?.map((el: Resultado) => (
          <TableRowStyled key={el?.contrato}>
            <TableCellStyled align="left">
              {el?.colaborador || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.documento(el?.cpfpassaporte) || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.contatoInternacional(el?.contato) || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.email || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.formatDDMMYYYY(el?.vldAcesso) || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.perfil || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.status || ' - - - -'}
            </TableCellStyled>
          </TableRowStyled>
        ))}
      </TableBodyStyled>
    </TableStyled>
  </TableContainerStyled>
)

export interface Resultado {
  colaborador?: any
  de: string
  dir: string
  ger?: any
  gg: string
  cpfpassaporte: string
  contato: string
  email: string
  vldAcesso: Date
  perfil: string
  status?: any
  contrato: string
  fornecedor?: string
}

export interface ResponseReports {
  resultado: Resultado[]
  totalContratada: number
  totalSubcontratada: number
  totalGeral: number
}
export default ContractView
